module.exports = __webpack_public_path__ + "static/media/animated_pratik.a218704c.png";